import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import type { UserIdType } from '../types.js'
import { UserIdCtor } from '../user-id.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'

@jsonClass('UserRecord')
export class UserRecord {
	//implements UserRecordUpdate {
	@jsonProperty(UserIdCtor)
	id: UserIdType

	@jsonProperty(String)
	get __type(): string {
		return 'UserRecord'
	}
	set __type(_) {
		/*ignore*/
	}

	@jsonProperty(String)
	userName: string

	@jsonProperty(String)
	firstName: string

	@jsonProperty(String)
	lastName: string

	@jsonProperty(String)
	email?: string

	@jsonProperty(String)
	mobilePhone?: string

	@jsonArrayProperty(String)
	roleNames?: string[]

	@jsonArrayProperty(String)
	permissionNames?: string[]

	@jsonArrayProperty(String)
	groupNames?: string[]
	@jsonProperty(UserRecord)
	manager?: UserRecord

	constructor(
		init?: Partial<UserRecord> &
			Pick<UserRecord, 'roleNames' | 'permissionNames' | 'groupNames'>,
	) {
		assignCommonProperties(this, init)
	}

	getName() {
		return `${this.firstName} ${this.lastName}`
	}

	hasRole(roleName: string) {
		return !!this.roleNames.find((role) => role == roleName)
	}

	hasSystemRole(roleName: string) {
		return this.hasRole(`System.${roleName}`)
	}

	hasPermission(permissionName: string) {
		return !!this.permissionNames.find(
			(permission) => permission == permissionName,
		)
	}

	hasSystemPermission(permissionName: string) {
		return this.hasPermission(`System.${permissionName}`)
	}

	toUserIdAndName() {
		const data = {
			userId: this.id,
			name: this.getName(),
		}

		const { UserIdAndName } = (globalThis as any).System ?? {}
		if (UserIdAndName) {
			return new UserIdAndName(data)
		}
		return data
	}
}

export type UserRecordOptions =
	| {
			includeEmail?: boolean
			includePhone?: boolean
			includeRoles?: boolean
			includePermissions?: boolean
			includeGroups?: boolean
			includeManager?: boolean | UserRecordOptions
	  }
	| '*'
